<template>
  <div v-show="visitantFormIsVisible">
    <DialogBox title="" :loading="loading" :large="true" :not_header="true">
      <div class="row mt-4">
        <div class="col-12 text-center">
          <span class="">
            <h1>{{ is_pt_br ? "Ola" : "Hello" }}!</h1>
            {{
              is_pt_br
                ? "Informe seus dados e tenha acesso a nossa plataforma"
                : "Enter your data and have access to our platform"
            }}
            <br />
          </span>
        </div>
      </div>
      <form v-if="is_cadaster" class="row px-3 mt-4">
        <legend class="divider-top pt-4 col-12">
          {{ is_pt_br ? "Informe os dados" : "Enter the data" }}:
        </legend>
        <div class="col-12 col-md-6 form-group">
          <input
            type="text"
            v-model="person_response"
            :placeholder="is_pt_br ? 'Nome' : 'Name'"
            class="form-control"
          />
        </div>
        <div class="col-12 col-md-6 form-group">
          <input
            type="phone"
            v-model="phone"
            :placeholder="is_pt_br ? 'Telefone' : 'Phone'"
            v-debounce:500ms="formatPhone"
            class="form-control"
          />
        </div>
        <div class="col-12 form-group">
          <input
            type="text"
            v-model="company"
            :placeholder="is_pt_br ? 'Nome da empresa' : 'Company name'"
            class="form-control"
          />
        </div>
        <div class="col-12 form-group">
          <input
            type="email"
            v-model="email"
            :placeholder="is_pt_br ? 'E-mail para contato' : 'Contact email'"
            class="form-control"
          />
        </div>

        <div class="d-flex align-items-center mb-4 px-5 col-12 form-check">
          <input
            class="form-check-input"
            type="checkbox"
            id="flexCheckDefault"
            v-model="accept_notification"
          />
          <label class="form-check-label" for="flexCheckDefault">
            {{
              is_pt_br
                ? "Aceita envio de atualizações, oportunidades e ofertas?"
                : "Accepts submission of updates, opportunities and offers"
            }}
          </label>
        </div>
      </form>

      <form v-else class="row px-3 mt-4">
        <legend class="divider-top pt-4 col-12">
          {{
            is_pt_br
              ? "Verifique as informações e acessa a plataforma"
              : "Check the information and access the platform"
          }}
          :
        </legend>
        <div class="col-12 form-group">
          <input
            type="text"
            v-model="company"
            :placeholder="is_pt_br ? 'Nome da empresa' : 'Company name'"
            class="form-control"
          />
        </div>
        <div class="col-12 form-group">
          <input
            type="email"
            v-model="email"
            :placeholder="is_pt_br ? 'E-mail para contato' : 'Contact email'"
            class="form-control"
          />
        </div>
      </form>
      <div class="px-3">
        <div
          v-show="mensageError !== ''"
          class="col-12 alert alert-danger"
          role="alert"
        >
          {{ mensageError }}
        </div>
      </div>

      <template v-slot:footer>
        <div
          v-if="is_cadaster"
          class="px-3 d-flex flex-column justify-content-between"
        >
          <button
            @click.prevent="handleCadasterVisitant('create')"
            class="mt btn btn-dark"
          >
            {{ is_pt_br ? "Cadastrar" : "Register" }}
          </button>
          <button
            @click.prevent="is_cadaster = !is_cadaster"
            class="my-2 btn btn-outline-dark"
          >
            {{ is_pt_br ? "Já me cadastrei!" : "I've already registered" }}
          </button>
          <button
            style="border: none"
            @click.prevent="backLogin"
            class="my-1 btn btn-outline-danger"
          >
            {{ is_pt_br ? "Não tenho interesse" : "I'm not interested" }}
          </button>
        </div>

        <div v-else class="px-3 d-flex flex-column justify-content-between">
          <button
            @click.prevent="handleCadasterVisitant('verify')"
            class="mt btn btn-dark"
          >
            {{ is_pt_br ? "Verificar" : "Check" }}
          </button>
          <button
            @click.prevent="is_cadaster = !is_cadaster"
            class="my-2 btn btn-outline-dark"
          >
            {{ is_pt_br ? "Voltar para cadastro" : "Back to register" }}
          </button>
        </div>
      </template>
    </DialogBox>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import DialogBox from "../utils/DialogBox.vue";
export default {
  name: "VisitantForm",

  components: {
    DialogBox,
  },
  computed: {
    ...mapGetters("user", ["visitantFormIsVisible"]),
    is_pt_br() {
      return this.$store.getters.is_pt_br;
    },
  },
  data() {
    return {
      is_cadaster: true,
      person_response: "",
      company: "",
      email: "",
      phone: "",
      mensageError: "",
      loading: false,
      accept_notification: false,
    };
  },

  methods: {
    ...mapActions("user", [
      "setVisibilityVisitantForm",
      "createVisitor",
      "verifyVisitor",
    ]),
    backLogin() {
      this.$router.push({ name: "Login" });
    },
    emitError(error) {
      this.mensageError = error;
      setTimeout(() => {
        this.mensageError = "";
      }, 4000);
    },
    async handleCadasterVisitant(mode) {
      if (this.validator(mode)) {
        const data = {
          name: this.person_response,
          company_name: this.company,
          email: this.email,
          phone: this.phone,
          accept_notification: this.accept_notification,
        };
        this.loading = true;
        mode === "create"
          ? await this.createVisitor(data)
              .then((res) => {
                if (res.data) {
                  this.setVisibilityVisitantForm(false);
                }
              })
              .catch((error) =>
                this.emitError(
                  this.is_pt_br
                    ? "Algo deu errado tente novamente!"
                    : "Something went wrong try again"
                )
              )
          : await this.verifyVisitor(data)
              .then((res) => {
                if (res.data) {
                  this.setVisibilityVisitantForm(false);
                } else {
                  this.emitError(
                    this.is_pt_br
                      ? "Cadastro não encontrado, verifique os dados!"
                      : "Registration not found, check data"
                  );
                }
              })
              .catch((error) =>
                this.emitError(
                  this.is_pt_br
                    ? "Algo deu errado tente novamente!"
                    : "Something went wrong try again"
                )
              );
        this.loading = false;
      } else {
        this.loading = false;
      }
      // this.setVisibilityVisitantForm(false);
    },
    validator(mode) {
      if (mode == "create") {
        if (
          !this.person_response ||
          !this.company ||
          !this.email ||
          !this.phone
        ) {
          this.emitError(
            this.is_pt_br ? "Preencha todos os campos!" : "Fill in all fields!"
          );
          return false;
        }
        if (!this.validateEmail(this.email)) {
          this.emitError(this.is_pt_br ? "Email invalido" : "Invalid email");
          return false;
        }
        if (!this.accept_notification) {
          this.emitError(
            this.is_pt_br
              ? "Aceite os termos para continuar!"
              : "Accept the terms to continue!"
          );
          return false;
        }
        return true;
      } else {
        if (!this.company || !this.email) return false;
        else return true;
      }
    },

    validateEmail(email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },

    formatPhone(item) {
      if (item.length < 15) {
        let a = item
          .replace(/\D/g, "")
          .replace(/^(\d{2})(\d{4})?(\d{4})?/, "($1) $2-$3");
        this.phone = a;
      } else {
        let a = item
          .replace(/\D/g, "")
          .replace(/^(\d{2})(\d{5})?(\d{4})?/, "($1) $2-$3");
        this.phone = a;
      }
    },
  },
};
</script>

<style scoped>
.form-check-label {
  font-size: 14px;
}
</style>
